module.exports = __webpack_public_path__ + "static/media/undraw_female_avatar_w3jk.580ce6fe.png";